var FormFieldAddress = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

FormFieldAddress.prototype.init = function(){

	var $select = this.options.$el;

	// 1. On trouve l'option vide générée par Formie (ou on la crée)
	var $emptyOption = $select.find('option[value=""]');
	if ($emptyOption.length === 0) {
		$select.prepend('<option value="">---</option>');
		$emptyOption = $select.find('option[value=""]');
	}

	// 2. On change son texte pour '---'
	$emptyOption.text('---');

	// 3. Marquer comme initialisé pour éviter le double-init dans le cas repeater
	$select.data('formfield-address-initialized', true);

	// 4. Si la valeur est vide ou 'AF' (Afghanistan, valeur par défaut de certains scripts tiers),
	// on la force à être vide. setTimeout(0) garantit que ce reset s'applique après toute
	// initialisation synchrone externe (GooglePlaceField, MutationObservers, Formie).
	setTimeout(function() {
		if (!$select.val() || $select.val() === 'AF') {
			$select.val('');
			$select.find('option').prop('selected', false);
			$emptyOption.prop('selected', true);
		}
	}, 0);

};

// Gestion des champs adresse ajoutés dynamiquement via le repeater Formie.
// Écoute tout bouton [data-add-repeater-row] (générique, quelle que soit la valeur de l'attribut).
$(document).on('click', '[data-add-repeater-row]', function() {
	var $button = $(this);
	// setTimeout(0) laisse Formie terminer le rendu du nouveau rang avant d'initialiser
	setTimeout(function() {
		var $form = $button.closest('form');
		if ($form.length === 0) return;

		$form.find('select[data-country]').each(function() {
			if (!$(this).data('formfield-address-initialized')) {
				new FormFieldAddress({ $el: $(this) }).init();
			}
		});
	}, 0);
});

export default FormFieldAddress;
